export const imgBrandStyle = `
	position: absolute;
    top: 35px;
    right: 15px;
`;
